<template>
  <div class="w-full mt-12">
    <div
      @click="goBack"
      class="w-full flex justify-start h-20 top-0 pl-4 md:pl-10 pt-8 fixed bg-white z-10 cursor-pointer"
    >
      <logo-icon />
    </div>

    <div class="w-full flex justify-center">
      <div
        class="w-full mt-6 md:pt-4 flex justify-center item-center mx-2 md:w-441px"
      >
        <o-card class="w-full mx-2">
          <div class="md:p-4">
            <span class="flex justify-center font-bold text-xl my-4"
              >Forgot Password</span
            >
            <div
              style="word-break: normal"
              class="text-center text-sm text-gray-400 my-3"
            >
              <i
                >Please enter your email to receive a link to create a new
                password</i
              >
            </div>
            <el-form
              @keyup.enter.native="
                validateForgotPasswordForm('forgotPasswordForm')
              "
              label-position="top"
              class="my-6"
              :model="forgotPasswordForm"
              ref="forgotPasswordForm"
              :rules="rules"
              label-width="80px"
              size="normal"
            >
              <el-form-item label="Email" prop="email">
                <el-input
                  name="email"
                  placeholder="name@example.com"
                  type="email"
                  v-model="forgotPasswordForm.email"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <o-button
                  class="text-white"
                  :loading="isLoading"
                  @click="validateForgotPasswordForm('forgotPasswordForm')"
                >
                  {{
                    !isLoading ? 'Send recovery link' : 'Sending...'
                  }}</o-button
                >
              </el-form-item>
              <p
                class="flex justify-center text-lg lg:text-normal cursor-pointer"
                @click="goBack"
              >
                cancel
              </p>
            </el-form>
          </div>
        </o-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'forgotPassword',
  data () {
    return {
      rules: {
        email: [
          {
            required: true,
            type: 'email',
            message: 'Kindly enter a valid email.',
            trigger: ['blur', 'change']
          }
        ]
      },
      forgotPasswordForm: {
        email: ''
      },
      isLoading: false
    }
  },
  methods: {
    goBack () {
      this.$router.push('login')
    },
    validateForgotPasswordForm (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.getRecoveryLink()
        } else {
          this.$notify.error({
            title: 'Email required',
            message: 'Please enter your valid email',
            position: 'top-right'
          })
        }
      })
    },
    getRecoveryLink () {
      const vm = this
      this.isLoading = true
      this.$store
        .dispatch('auth/forgotPassword', this.forgotPasswordForm.email)
        .then((res) => {
          this.$swal({
            icon: 'success',
            title: 'Sent!',
            text: 'The password reset link has been sent to your email, kindly check',
            confirmButtonText: 'confirm',
            iconColor: this.$primaryColor,
            allowOutsideClick: false
          })
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  components: {
    logoIcon: () => import('@/assets/images/AppLogo.vue')
  }
}
</script>

<style scoped>
>>> .el-form--label-top .el-form-item__label {
  padding: 0;
}
>>> .el-input__inner {
  border-radius: 8px;
  border-color: #c7c8d2;
  height: 48px;
}
>>> .el-card__body {
  padding: 10px;
}
>>> .el-form-item__label,
>>> .el-form-item__content {
  line-height: 16px;
  font-size: 12px;
  font-weight: 600;
}
</style>
